<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Редактирование</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
                <v-btn color="error" class="v-btn--save" @click="dialog = true">
                    Удалить
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        ref="news_name"
                        v-model="news.name"
                        v-validate="'required'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        text
                        solo
                        single-line
                        required/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Короткое описание</v-subheader>
                            <v-textarea
                                ref="news_description"
                                v-model="news.description"
                                v-validate="'required|max:140'"
                                data-vv-name="description"
                                :error-messages="errors.collect('description')"
                                text
                                solo
                                single-line
                                required
                                counter="140"/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="news.status ? 'Включен' : 'Отключен'" v-model="news.status"
                                        class="mt-0"/>
                        </v-flex>
                        <v-spacer/>
                        <upload-img :image-width="800" :image-height="800" v-model="news.img" :content-area="5"
                                    style="max-width: 253px;">
                            <div slot="activator">
                                <v-avatar size="200px" v-ripple tile v-if="news.img.imageURL">
                                    <img :src="news.img.imageURL" alt="Изображение для категории"/>
                                </v-avatar>
                                <v-avatar size="200px" v-ripple tile v-else-if="!news.img.imageURL && news.img">
                                    <v-img :src="rootURL + news.img" aspect-ratio="1">
                                        <v-layout
                                            slot="placeholder"
                                            fill-height
                                            align-center
                                            justify-center
                                            ma-0>
                                            <v-progress-circular indeterminate color="grey"></v-progress-circular>
                                        </v-layout>
                                    </v-img>
                                </v-avatar>
                                <v-avatar size="200px" v-ripple class="grey lighten-3" tile v-else>
                                    <img src="/static/img/media/image_blank.svg"
                                         alt="Нажмите чтобы добавить картинку для категории"/>
                                </v-avatar>
                            </div>
                        </upload-img>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Основной Текст</v-subheader>
                    <wysiwyg v-model="news.text"/>
                </v-flex>
            </v-form>
            <v-dialog v-model="dialog" persistent max-width="45%">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Подтверждение удаление</h4>
                    </v-card-title>
                    <v-card-text>
                        Новость/События будет удалено! <br/> Вы уверены что хотите этого?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <template v-if="waitDelete">
                            <v-progress-linear indeterminate color="warning" class="mb-0"/>
                        </template>
                        <template v-else>
                            <v-btn color="info" class="v-btn--save" @click="deleteNE">
                                Продолжить
                            </v-btn>
                            <v-btn color="error" class="v-btn--save" @click="dialog = false">
                                Отменить
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
    import config from '../../../config'
    import News from '../../../api/event'
    import UploadImg from '../../../components/Media/Upload'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'editNews',
        components: {
            UploadImg,
            Loader
        },
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            loader: false,
            news: {
                name: '',
                description: '',
                text: '',
                status: true,
                img: ''
            },
            rootURL: '',
            dialog: false,
            waitDelete: false,
            dictionary: {
                custom: {
                    name: {
                        required: 'Название не заполнено'
                    },
                    description: {
                        required: 'Заполните описание'
                    }
                }
            }
        }),
        mounted () {
            this.rootURL = config.rootPath
            this.$validator.localize('ru', this.dictionary)
            this.getNews(this.$route.params.newsEventId)
        },
        methods: {
            getNews (newsId) {
                this.loader = true

                News
                    .getById(newsId)
                    .then(response => this.news = response.data.data)
                    .catch(error => {
                        this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        this.$router.push({ name: 'stockRegister' })
                    })
                    .finally(() => this.loader = false)
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        News
                            .edit(this.news)
                            .then(response => {
                                this.$store.commit('updateNewsEvent', response.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Отлично! Запись отредактировано',
                                    color: 'success'
                                })
                                this.$router.push({ name: 'newsEventsRoot' })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            },
            deleteNE () {
                this.waitDelete = true

                News
                    .delete(this.news.id)
                    .then(response => {
                        this.$store.commit('deleteNewsEvent', { id: this.news.id })
                        this.$store.commit('showSnackbar', response.data.data)
                        this.$router.push({ name: 'newsEventRoot' })
                    })
                    .catch(error => new Error(error))
                    .finally(() => {
                        this.dialog = false
                        this.waitDelete = false
                    })
            }
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeRouteUpdate (to, from, next) {
            this.news = this.getNews(to.params.newsEventId)
            next()
        }
    }
</script>
